import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

import Clickable from 'components/Common/Clickable'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'

const Container = styled(Clickable)`
  position: relative;
  display: flex;
  height: fit-content;
  align-items: center;
  width: 100%;
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  border: 1px solid ${(props) => props.theme.palette.neutral.default.five};
  border-radius: ${(props) => props.theme.borderRadius.S};
`

const Item = styled.div`
  padding: ${rem(8)} ${rem(16)};
  width: 100%;
  justify-self: stretch;

  &:not(:first-child) {
    border-left: 1px solid ${(props) => props.theme.palette.neutral.default.five};
  }
`

interface BaseProps extends PropsWithChildren<{}> {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

interface Props extends BaseProps {
  title?: string
  subTitle?: string
}

const PLACE_DEFAULT_TITLE = 'Where'
const PLACE_DEFAULT_SUB_TITLE = 'Search for a destination or hotel'

export function PlaceInputTrigger({
  onClick,
  title = PLACE_DEFAULT_TITLE,
  subTitle = PLACE_DEFAULT_SUB_TITLE,
}: Props) {
  return (
    <Container onClick={onClick}>
      <Item>
        <Caption variant="large" weight="bold">
          {title}
        </Caption>
        <BodyText colour="neutral-three" variant="medium">
          {subTitle}
        </BodyText>
      </Item>
    </Container>
  )
}
